<template>
  <v-container fluid class="ma-0 pa-0">
    <slot />
  </v-container>
</template>

<script>
export default {
  name: 'AppModalContainer'
}
</script>

<style>

</style>